var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toPoint } from '../../../utils';
import { asyncInitial } from '../async/reducers';
import { getZoneName } from './selectors';
export var setZoneNameReducer = function (state, payload) { return (__assign(__assign({}, state), { zone: __assign(__assign({}, state.zone), { name: payload.name }) })); };
export var setZonePointReducer = function (state, payload) { return (__assign(__assign({}, state), { zone: __assign(__assign({}, state.zone), { point: payload.point }) })); };
export var updateZonePointBySuggest = function (state, payload) {
    var _a;
    var response = payload.data;
    var currZoneName = getZoneName(state);
    var nextZoneName = response.nearest_zone;
    var nextZonePoint = toPoint((_a = response.results[0]) === null || _a === void 0 ? void 0 : _a.pos);
    // если саджест вернул имя зоны и оно не совпадает с текущим,
    // то нужно сборить имя и координаты зоны, при этом обновится все остальное
    // zoneinfo, paymentmethods и тд
    if (currZoneName && nextZoneName && currZoneName !== nextZoneName && nextZonePoint) {
        // обновим точку зоны
        var nextState = setZonePointReducer(state, {
            point: nextZonePoint,
        });
        // при обновлении зоны имя нужно сборить, чтобы лишний раз не ходить в эстимейт
        nextState = setZoneNameReducer(nextState, {
            name: undefined,
        });
        // до кучи сбросим загруженную зону, чтобы сбросить тарифы
        nextState = asyncInitial(nextState, { key: 'zoneInfo' });
        return nextState;
    }
    return state;
};
